'use strict';

angular.module('internal.inspections')
    .controller('InternalInspectionsAutoNumber', ['$scope', 'InspectionAutoNumbers', function ($scope, InspectionAutoNumbers) {
        $scope.loading = false;
        $scope.saving = false;
        $scope.auto_number = {};

        $scope.get = function () {
            $scope.loading = false;

            InspectionAutoNumbers.get().then(function (auto_number) {
                auto_number.date_format = auto_number.date_format.toLowerCase();
                auto_number.next_number = Number(auto_number.next_number);
                $scope.auto_number = auto_number;
                $scope.loading = false;
            })
        }

        $scope.get();

        $scope.save = function () {
            $scope.saving = true;

            InspectionAutoNumbers.save($scope.auto_number).then(function () {
                $scope.saving = false;
                $scope.get();
            })
        }
    }])
;